module.exports = "/_next/static/images/a8d8ba9c18140adceb83cefbbcd65666-about-us-hero-desktop.jpg";